<ng-container>
  <div fxLayout="row">
    <p class="font-bold font-md width-100" style="margin-top:0"> Add a reference</p>
    <mat-icon (click)="onNoClick()" style="cursor:pointer">clear</mat-icon>
  </div>

  <a style="cursor:pointer" class="sparro-grey-900 font-sm" [class.active]="view" (click)="toggle()">Webpage</a>&nbsp; | &nbsp;
  <a style="cursor:pointer" class="sparro-grey-900 font-sm" [class.active]="!view" (click)="toggle()">Publication</a>

  <div *ngIf="view" class="width-100">
    <form class="width-100" [formGroup]="webpageForm" style="margin-top:16px">
      <mat-form-field class="width-100" floatLabel="never">
        <input matInput class="font-sm font-light" placeholder="Title" formControlName="title" required>
      </mat-form-field>
      <mat-form-field class="width-100" floatLabel="never">
        <input matInput class="font-sm font-light" placeholder="URL" formControlName="url" required>
      </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="flex-end center" class="width-100" style="margin-top:16px">
      <uni-navigation-button style="cursor:pointer"
        default="Add"
        (click)="submitWebPage()"
        [disabled]="!webpageForm.valid"
        *ngIf="new"
        button_class="primary">
      </uni-navigation-button>
      <uni-navigation-button style="cursor:pointer"
        default="Save"
        (click)="submitWebPage()"
        [disabled]="!webpageForm.valid"
        *ngIf="!new"
        button_class="primary">
      </uni-navigation-button>
    </div>
  </div>

  <div *ngIf="!view" class="width-100">
    <form class="width-100" [formGroup]="publicationForm" style="margin-top:16px">
      <mat-form-field class="width-100" floatLabel="never">
        <input matInput class="font-sm font-light" placeholder="Publication title" formControlName="title" required>
      </mat-form-field>
      <mat-form-field class="width-100" floatLabel="never">
        <input matInput class="font-sm font-light" placeholder="Author" formControlName="author" required>
      </mat-form-field>
      <mat-form-field class="width-100" floatLabel="never">
        <input matInput class="font-sm font-light" placeholder="Publisher" formControlName="publisher" required>
      </mat-form-field>
      <div class="width-100 input-container">
        <mat-form-field class="width-100" floatLabel="never">
          <input matInput class="font-sm font-light" placeholder="Volume" formControlName="volume" required>
          <mat-hint>Please enter 10-13 characters</mat-hint>
        </mat-form-field>
        <mat-form-field class="width-100" floatLabel="never">
          <input matInput class="font-sm font-light" placeholder="ISBN" formControlName="isbn">
          <mat-hint>Please enter 10 or 13 digits</mat-hint>
        </mat-form-field>
      </div>
      
      <!-- TODO: Display min and max length errors -->
    </form>
    <div fxLayout="row" fxLayoutAlign="flex-end center" class="width-100" style="padding-top:16px">
      <uni-navigation-button style="cursor:pointer"
        default="Add"
        (click)="submitPublication()"
        [disabled]="!publicationForm.valid"
        *ngIf="new"
        button_class="primary">
      </uni-navigation-button>
      <uni-navigation-button style="cursor:pointer"
        default="Save"
        (click)="submitPublication()"
        [disabled]="!publicationForm.valid"
        *ngIf="!new"
        button_class="primary">
      </uni-navigation-button>
    </div>
  </div>
</ng-container>
